import { Link } from "react-router-dom";
import { FOOTER_LINKS } from "@/data/site";
import { OrayaMark } from "@/components/site/primitives";

export function Footer() {
  return (
    <footer className="border-t border-hairline/[0.06] bg-surface pt-20 pb-10" data-testid="site-footer">
      <div className="oraya-container">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <OrayaMark size={34} />
              <span className="display text-3xl font-medium tracking-[0.28em] text-ink">ORAYA</span>
            </div>
            <p className="text-subtle text-lg max-w-sm leading-relaxed">
              Building the intelligence layer for the real world.
            </p>
            <p className="text-subtle/60 text-sm mt-4">Intelligence, engineered.</p>
          </div>

          <div className="md:col-span-4 md:col-start-7">
            <h4 className="text-xs font-semibold tracking-[0.25em] uppercase text-subtle mb-6">Navigate</h4>
            <div className="grid grid-cols-2 gap-y-3">
              {FOOTER_LINKS.map((l) => (
                <Link key={l.to} to={l.to} data-testid={`footer-${l.label.toLowerCase()}`} className="text-subtle hover:text-ink transition-colors duration-300 text-sm">
                  {l.label}
                </Link>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-semibold tracking-[0.25em] uppercase text-subtle mb-6">Legal</h4>
            <div className="flex flex-col gap-3">
              <Link to="/privacy" data-testid="footer-privacy" className="text-subtle hover:text-ink transition-colors duration-300 text-sm">Privacy</Link>
              <Link to="/terms" data-testid="footer-terms" className="text-subtle hover:text-ink transition-colors duration-300 text-sm">Terms</Link>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-hairline/[0.06] flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-subtle/60 text-sm">© 2026 ORAYA. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <Link to="/admin" data-testid="footer-admin" className="text-subtle/50 hover:text-ink transition-colors duration-300 text-xs tracking-wide">Admin</Link>
            <Link to="/command/login" data-testid="footer-command" className="text-subtle/50 hover:text-ink transition-colors duration-300 text-xs tracking-wide">Command Center</Link>
            <p className="text-subtle/40 text-xs tracking-wide hidden md:block">Don't build another tool. Build the system.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
